import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export function ConfirmationRemoteAccessDialog({
  open,
  handleClose,
  handleConfirm,
}: {
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
}) {
  return (
    <Dialog open={open} onClose={handleClose} scroll="paper">
      <DialogTitle>Souhlas se vzdáleným přístupem</DialogTitle>
      <DialogContent dividers={true}>
        <DialogContentText component="div">
          <p>
            Badatel, který přistupuje k archiváliím Archivu Univerzity Karlovy
            pomocí osobního registrovaného účtu ve webové badatelně Archivu
            Univerzity Karlovy (rozhraní “Můj archiv”), tímto bere na vědomí a
            zavazuje se dodržovat následující pravidla. Sankcí za jejich
            porušení může být dočasné či trvalé odebrání možnosti vzdáleného
            přístupu k archiváliím Archivu UK:
          </p>
          <br />
          <ol>
            <li>
              Badatel si je vědom, že přístup k archiváliím či jejich digitálním
              kopiím prostřednictvím webové Badatelny UK je nahlížením do
              archiválií v souladu s § 18b, odst. 5b), § 34 a následujícími
              zákona č. 499/2004 Sb. o archivnictví a spisové službě v platném
              znění a v souladu s Badatelským řádem Archivu UK.
            </li>
            <li>
              Badatel udělením souhlasu potvrzuje, že si je vědom své osobní
              odpovědnosti za nakládání s informacemi, jež získal nahlížením do
              archiválií. Badatel se zavazuje, že své přístupové údaje
              neposkytne jiné osobě a v případě zcizení přístupových údajů tuto
              skutečnost neprodleně oznámí Archivu UK a změní si přihlašovací
              údaje prostřednictvím rozhraní na adrese https://ldapuser.cuni.cz/
              . Badatel je odpovědný za všechny aktivity, které pod svým
              uživatelským účtem vykonává.
            </li>
            <li>
              Archiválie a jejich digitální kopie jsou zpřístupněny pouze za
              účelem on-line studia, jejich distribuování, prodávání, využití v
              jiných projektech apod. je zakázáno. Taktéž je zakázáno je
              umísťovat na jiných www stránkách či je jakýmkoli způsobem bez
              svolení publikovat. Publikování jakékoliv části databáze je
              podmíněno souhlasem Archivu UK a uvedením řádné citace.
            </li>
            <li>
              Uživatel si je vědom, že případné stažené kopie archiválií v
              digitální podobě nebo digitalizovaných archiválií jsou
              reprodukcemi archiválií (viz čl. 5 badatelského řádu Archivu UK) a
              zavazuje se, že tyto reprodukce bude využívat pouze pro účely
              úřední nebo vlastní práce uvedené v badatelském listu v závislosti
              na případném předem uděleném souhlasu vlastníka archiválií nebo na
              ochraně případných autorských práv a práv souvisejících.
            </li>
            <li>
              Badatel je povinen udržovat aktuální kontaktní údaje uvedené v
              sekci Profil badatelského účtu, případně tyto změny osobně
              nahlásit obsluze badatelny Archivu UK.
            </li>
          </ol>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color="primary">
          Souhlasím
        </Button>
      </DialogActions>
    </Dialog>
  );
}
